const handleLinkClick = (e: MouseEvent) => {
  e.preventDefault();
  const currentTarget = e.currentTarget as HTMLAnchorElement;
  const body = document.querySelector('body');
  const submenu = currentTarget.parentElement.nextElementSibling;
  currentTarget.classList.toggle('active');
  submenu.classList.toggle('active');
  body.classList.toggle('overflow-hidden');
};

const init = (menuItem: HTMLElement) => {
  const menuLink = menuItem.querySelector<HTMLAnchorElement>('.menu__link');
  const menuLinkIcon = document.createElement('span');
  menuLink.appendChild(menuLinkIcon);
  menuLinkIcon?.addEventListener('click', (e: MouseEvent) => handleLinkClick(e));
};

export default init;
